import { SlateElement } from '@all-hands-hq/plex-graphql-schema';
import {
  BoldPlugin,
  CodePlugin,
  ExitBreakPlugin,
  ItalicPlugin,
  LinkPlugin,
  ListPlugin,
  SlatePlugin,
  SoftBreakPlugin,
  TablePlugin,
  UnderlinePlugin,
} from '@udecode/slate-plugins';
import isUrl from 'is-url';

export const SlatePluginOptions = {
  li: { type: 'list-item' },
  ul: { type: 'bulleted-list' },
  ol: { type: 'numbered-list' },
  p: { type: 'paragraph' },
  link: { type: 'link', isUrl, defaultType: 'paragraph' },
  table: { type: 'table' },
  tr: { type: 'table-row' },
  td: { type: 'table-cell' },
};

export const SlatePlugins: SlatePlugin[] = [
  BoldPlugin({ bold: { type: 'bold' } }),
  ItalicPlugin({ italic: { type: 'italic' } }),
  UnderlinePlugin({ underline: { type: 'underline' } }),
  CodePlugin({ code: { type: 'code', hotkey: 'mod+shift+c' } }),
  ListPlugin(SlatePluginOptions),
  LinkPlugin(SlatePluginOptions),
  TablePlugin(SlatePluginOptions),
  SoftBreakPlugin({
    rules: [
      {
        hotkey: 'shift+enter',
      },
      {
        hotkey: 'enter',
        query: {
          allow: ['block-quote'],
        },
      },
    ],
  }),
  ExitBreakPlugin({
    rules: [
      {
        hotkey: 'mod+enter',
        defaultType: 'paragraph',
        level: 0,
      },
      {
        hotkey: 'mod+shift+enter',
        defaultType: 'paragraph',
        before: true,
        level: 0,
      },
      {
        hotkey: 'enter',
        defaultType: 'paragraph',
        level: 0,
        query: {
          end: true,
          filter: (nodeEntry): boolean => {
            const node = (nodeEntry[0] as unknown) as SlateElement;
            return node.type === 'paragraph' && node.namedStyleType != null && node.namedStyleType !== 'NORMAL_TEXT';
          },
        },
      },
    ],
  }),
];
